__turbopack_context__.v({
  "caption": "PaymentOptions-module__aKDC4a__caption",
  "container": "PaymentOptions-module__aKDC4a__container",
  "content": "PaymentOptions-module__aKDC4a__content",
  "icons": "PaymentOptions-module__aKDC4a__icons",
  "seeAllButton": "PaymentOptions-module__aKDC4a__seeAllButton",
});
